document.querySelectorAll( '.b-content-cards' ).forEach( ( block ) => {

    /////////////////////
    // BLOCK CODE HERE //
    /////////////////////

} );
    